export default class AddHiveMenu {
  constructor() {
    this.menu = document.getElementById("add-hive-menu");
    this.menu.style.display = "flex";
    this.menu.innerHTML = `<h1>Add Hive</h1>
    <p>Walk To Hive Position</p>
    <p>Enter To Continue</p>
    `;
  }
  changeHtml(markup) {
    this.menu.innerHTML = markup;
  }
  destroy() {
    this.menu.style.display = "none";
  }
}
